'use client';

/**
 * FastTierSourceTag — a small "which SP did the fast tier come from?" line.
 *
 * Temporary transparency chrome for the un-re-indexed era: the fast-tier
 * cards (short / long / followups / sources / grounding) all paint off the
 * top `:SemanticProfile` hit, and right now that hit is often a generic
 * comprehensive-doc SP. This tag puts the source doc on the card so the
 * "why is this answer so generic?" question answers itself. Reads
 * `useDocsStore.response.summary.fast.{source_path,media_sid}`; renders
 * nothing if neither is set or the response is LLM-tier.
 *
 * @layer presentation
 * @arch_component_type widget
 * @arch_domain canvas
 */

import { useDocsStore } from '@/lib/stores/docs-store';
import { cn } from '@/lib/utils/cn';


export function FastTierSourceTag({ className }: { className?: string } = {}) {
  const fast = useDocsStore((s) => s.response?.summary?.fast);
  const label = fast?.source_path ?? fast?.media_sid;
  if (!label) return null;
  return (
    <div
      className={cn(
        'text-[10px] font-mono text-muted-foreground/55 mb-2 truncate',
        className,
      )}
      title="The fast-tier SemanticProfile this card's content came from"
    >
      fast tier · {label}
    </div>
  );
}
